import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { MdPlayArrow } from 'react-icons/md'
import Scaffold from 'shared/components/ScaffoldNew'
import { colors } from 'shared/styles/colors'
import { validateTypeFile } from 'shared/utils/validates'
import { useMotoristas } from '../../../../hooks/useMotoristas'
import { IPhotoComponentsProps } from './PhotoComponents.types'
import {
  Container,
  ContainerPhoto,
  StyledInputFile,
  SubTitle,
  Title,
} from './styles'

const Photo: FunctionComponent<IPhotoComponentsProps> = () => {
  const {
    motoristas,
    setMotoristas,
    handleBackButton,
    handleNextButton,
    loading,
  } = useMotoristas()

  const [formOk, setFormOk] = useState(false)
  const [isWrongExtension, setIsWrongExtension] = useState(false)

  useEffect(() => {
    if (motoristas && motoristas.doc_name) {
      setFormOk(true)
    }
  }, [motoristas, setFormOk])

  const handleInputFile = useCallback(
    (base64, fileName) => {
      setMotoristas({
        doc_name: fileName,
        doc_imagem_frente: base64,
        doc_imagem_verso: base64,
      })
      if (validateTypeFile(fileName)) {
        setFormOk(true)
        setIsWrongExtension(false)
      } else {
        setIsWrongExtension(true)
        setFormOk(false)
      }
    },
    [setMotoristas, setFormOk],
  )

  return (
    <Scaffold
      showFooterScaffold
      titleBackButton="Voltar"
      onClickBackButton={handleBackButton}
      icon={MdPlayArrow}
      titleNextButton="Próximo"
      onClickNextButton={handleNextButton}
      isNextButtonDisabled={!formOk}
      color={formOk ? colors.green : colors.gray}
      loading={loading}
      titleHeader="Novo motorista"
    >
      <Container>
        <Title>Documento CNH</Title>
        <ContainerPhoto>
          <SubTitle>Envie uma foto da CNH do motorista</SubTitle>
          <StyledInputFile
            id="photo-create-motorista"
            file={motoristas && motoristas.doc_name}
            onSelectFile={handleInputFile}
            isWrongExtension={isWrongExtension}
          />
        </ContainerPhoto>
      </Container>
    </Scaffold>
  )
}

export default Photo
